import ENDPOINT from '@/config/endpoint'
import request from '@/utils/request'

async function fetchBlogTag(params) {
  return await request({
    url: `${ENDPOINT.BLOG_API_URL}/tags`,
    method: 'get',
    params,
  })
}

async function fetchBlogPost(params) {
  return await request({
    url: `${ENDPOINT.BLOG_API_URL}/posts`,
    method: 'get',
    params,
  })
}

async function fetchBlogUser(params) {
  return await request({
    url: `${ENDPOINT.BLOG_API_URL}/users`,
    method: 'get',
    params,
  })
}

async function fetchBlogCategory(params) {
  return await request({
    url: `${ENDPOINT.BLOG_API_URL}/categories`,
    method: 'get',
    params,
  })
}

async function subscribe(data) {
  return await request({
    url: `https://api.cystack.net/portal/v1/mail/subscribers`,
    method: 'post',
    data,
  })
}

async function fetchBlogHead(params) {
  return await request({
    url: `${ENDPOINT.BLOG_RANKMATH}/getHead`,
    method: 'get',
    headers: {
      'CF-Access-Client-Id': process.env.NEXT_PUBLIC_SME_CLIENT_ID,
      'CF-Access-Client-Secret': process.env.NEXT_PUBLIC_SME_CLIENT_SECRET,
    },
    params,
  })
}

export default {
  fetchBlogTag,
  fetchBlogPost,
  fetchBlogUser,
  fetchBlogCategory,
  subscribe,
  fetchBlogHead,
}
